import { useTranslation } from 'react-i18next';
import type { StatoUscita } from '../../api/uscite';

// Lo stato è DERIVATO dal backend a ogni lettura (fattura collegata, pagata,
// annullata). Qui si traduce e si colora, non si ricalcola: una seconda
// derivazione nel frontend sarebbe una seconda verità.
const CLASSI: Record<StatoUscita, string> = {
  registrata: 'bg-stone-bg text-ink-mid',
  fatturata: 'bg-sage-light text-sage-dark',
  pagata: 'bg-green-100 text-green-700',
  annullata: 'bg-accent-danger-bg text-accent-danger',
};


export default function StatoUscitaBadge({ stato }: { stato: StatoUscita }) {
  const { t } = useTranslation();
  // Chiavi LETTERALI dentro `t(...)` e non `t(\`uscite.stato.${stato}\`)`:
  // check-i18n verifica le chiavi che riesce a leggere staticamente, e una
  // composta a runtime richiederebbe l'allowlist dei `t(variabile)`.
  const etichette: Record<StatoUscita, string> = {
    registrata: t('uscite.stato.registrata'),
    fatturata: t('uscite.stato.fatturata'),
    pagata: t('uscite.stato.pagata'),
    annullata: t('uscite.stato.annullata'),
  };
  return (
    <span
      data-testid={`stato-uscita-${stato}`}
      className={`inline-flex items-center text-xs px-2 py-0.5 rounded-full font-medium ${CLASSI[stato]}`}
    >
      {etichette[stato]}
    </span>
  );
}
